var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import di from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import { useSelector } from "react-redux";
import Editicon from "@frameworks/web/assets/images/features/BasicProfile/Editicon.svg";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import BasicProfileErrorMsg from "../../BasicProfileErrorMsg";
import _ from "underscore";
import { navigateSelf } from "@frameworks/web/components/features/ServiceRequest/ServiceRequest";
import { EServiceRequest, SRRedirectionUrl, } from "@frameworks/web/components/features/ServiceRequest/constant";
import Common_Shimmer from "@frameworks/shared-library/components/common_shimmer";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
var BrokerageSegmentsData = function () {
    var device = DeviceContext();
    var accData = JSON.parse(localStorage.getItem("acc_data"));
    var _a = __read(useState(), 2), segmentDetails = _a[0], setSegmentDetails = _a[1];
    var columnsHead = ["BSE", "F&O", "CDS", "COMM", "MF"];
    var rowHead = ["BSE", "NSE", "MCX", "NCDEX"];
    var finalResult = [];
    var _b = __read(useState(false), 2), isLoader = _b[0], setIsLoader = _b[1];
    var _c = __read(React.useState({ isOpen: false, errMsg: null }), 2), errMsg = _c[0], setErrMsg = _c[1];
    var _d = useSelector(function (state) { return state.LoginFlow.ClientLoginDataReducers; }, _.isEqual), accountsData = _d.data, accountsDataLoader = _d.loader, accountsDataError = _d.errorData;
    var BrokerageSegmentsDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            payload = {
                accCode: (accData === null || accData === void 0 ? void 0 : accData.accType) === "COMEQ"
                    ? (accData === null || accData === void 0 ? void 0 : accData.prefAccTyp) == "EQ"
                        ? accData === null || accData === void 0 ? void 0 : accData.eqAccID
                        : accData === null || accData === void 0 ? void 0 : accData.coAccID
                    : (accData === null || accData === void 0 ? void 0 : accData.accType) === "EQ"
                        ? accData === null || accData === void 0 ? void 0 : accData.eqAccID
                        : accData === null || accData === void 0 ? void 0 : accData.coAccID,
            };
            setIsLoader(true);
            di.basicProfile
                .getBrokerageSegmentData(payload)
                .then(function (data) {
                setSegmentDetails(data);
                setIsLoader(false);
            })
                .catch(function (err) {
                setIsLoader(false);
                setErrMsg({ isOpen: true, errMsg: err });
            });
            return [2 /*return*/];
        });
    }); };
    var findRow = function (val) {
        var _a;
        return (_a = segmentDetails === null || segmentDetails === void 0 ? void 0 : segmentDetails.activatedSegmentList) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.exc === val; });
    };
    var formRowsandColumns = function () {
        if (segmentDetails) {
            rowHead.map(function (rowItem) {
                var col = findRow(rowItem);
                var res = [];
                columnsHead.map(function (colItem) {
                    var _a;
                    if (colItem === "F&O") {
                        colItem = "FNO";
                    }
                    var val = (_a = col === null || col === void 0 ? void 0 : col.segmentList) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.seg === colItem; });
                    val ? res.push(val.active) : res.push("NA");
                });
                finalResult.push(res);
            });
        }
    };
    if (segmentDetails) {
        formRowsandColumns();
    }
    React.useEffect(function () {
        BrokerageSegmentsDetails();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null, isLoader ? (React.createElement(Common_Shimmer, null)) : errMsg.isOpen ? (React.createElement(ErrorNotification, { error: errMsg.errMsg, isOpen: errMsg.isOpen, displayType: ErrorDisplayType.INSECTION })) : (finalResult === null || finalResult === void 0 ? void 0 : finalResult.length) > 0 ? (React.createElement(React.Fragment, null,
            device && !(device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement("div", { className: "grid-2 align-items-center mgt-20 mb-15" },
                React.createElement("span", { className: "DMSanM_14_500 txt_primaryGrey" }, "Activated Segments"),
                React.createElement("span", { className: "txt-midnight-blue text-right DMSansMedium_12_500 hand_cursor", onClick: function (e) {
                        e.stopPropagation();
                        navigateSelf(SRRedirectionUrl[EServiceRequest.SEGMENT_ACTIVATION]);
                    } },
                    React.createElement("img", { src: Editicon }),
                    React.createElement("span", { className: "mgl-5" }, "Activate Segments")))),
            React.createElement("div", null, finalResult ? (React.createElement("table", { className: "table table-border brokeragesegment-table mt-10 mb-0" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        columnsHead.map(function (colItem, colid) {
                            return React.createElement("th", { key: colid }, colItem);
                        }))),
                React.createElement("tbody", null, finalResult.map(function (rowItem, headId) {
                    return (React.createElement("tr", { key: headId },
                        React.createElement("td", null, rowHead[headId]),
                        " ", columnsHead === null || columnsHead === void 0 ? void 0 :
                        columnsHead.map(function (val, id) {
                            return (React.createElement("td", { key: id }, finalResult && finalResult.length > headId
                                ? (finalResult[headId][id] === "YES" && (React.createElement("i", { className: "edel-icon-cross-2" }))) ||
                                    (finalResult[headId][id] === "NO" && (React.createElement("i", { className: "edel-icon-bold-close" }))) ||
                                    (finalResult[headId][id] === "NA" && (React.createElement("i", { className: "edel-icon-bold-close" })))
                                : ""));
                        })));
                })))) : (React.createElement(React.Fragment, null, "No Data Available"))))) : (React.createElement("div", { className: "py-5" },
            React.createElement(BasicProfileErrorMsg, { errorName: "Activated Segments Data" }))))));
};
export default BrokerageSegmentsData;
